export default __webpack_public_path__ + "static/media/calendar_icon.7d390347.svg";